module.exports = __webpack_public_path__ + "img/tesla.707cf046.svg";